import { Box, useTheme } from '@mui/material';
import React, { FC, ReactElement, ReactNode } from 'react';
import { customColors } from '../../constants/theme';
import ReviewHeader from './ReviewHeader';
import ReviewFooter from './ReviewFooter';
import ReviewContent from './ReviewContent';
import { IReviewDateFormat, IReviewNewProps } from '../../shared/interfaces/IReviewNew';
import { IReviewMetadata } from '../../services/CommentAiService';
import { buildAiReviewDescriptor } from '../../shared/helpers/AiReviewDescriptor';

interface Props extends IReviewNewProps {
  checked?: boolean;
  children: ReactNode;
  rating: number;
  subHeader?: ReactElement;
  reviewLink?: string;
  reviewFor?: string;
  currentStatus?: string;
  dateFormat?: IReviewDateFormat;
  originalRating?: number;
}
const ReviewWrapper: FC<Props> = ({
  checked,
  children,
  communityManagement,
  commentingModule,
  hideFooter,
  subHeader,
  statusModule,
  deletionModule,
  reviewEntry,
  rating,
  hideHeader,
  originalRating,
  reviewLink,
  reviewFor,
}) => {
  const theme = useTheme();
  const descriptor = buildAiReviewDescriptor(reviewEntry);

  const reviewMeta: IReviewMetadata = {
    author: descriptor.author,
    score: rating,
    reviewerType: [reviewEntry.review.position, reviewEntry.review.employmentStatus]
      .filter(Boolean)
      .join(' '),
    platform: reviewEntry.platform,
  };

  return (
    <Box
      sx={{
        p: theme.spacing(1),
        mb: theme.spacing(2),
        border: `1px solid ${checked ? theme.palette.primary.main : theme.palette.divider}`,
        borderRadius: `${theme.shape.borderRadius}px`,
        backgroundColor: checked
          ? `rgba(${customColors.primary.main}, 0.1)`
          : theme.palette.background.paper,
      }}
    >
      <ReviewHeader
        rating={rating}
        reviewEntry={reviewEntry}
        commentingModule={commentingModule}
        hide={hideHeader ?? false}
        originalRating={originalRating ?? 0}
        statusModule={statusModule}
        deletionModule={deletionModule}
        reviewLink={reviewLink}
        reviewFor={reviewFor}
        communityManagement={communityManagement}
        AIInput={descriptor.prompt}
        noReviewText={!descriptor.hasReviewText}
        reviewMeta={reviewMeta}
      ></ReviewHeader>
      <>{subHeader && subHeader}</>
      <ReviewContent>{children}</ReviewContent>
      <ReviewFooter
        commentingModule={commentingModule}
        communityManagement={communityManagement}
        statusModule={statusModule}
        input={descriptor.prompt}
        hide={hideFooter ?? false}
        noReviewText={!descriptor.hasReviewText}
        reviewEntry={reviewEntry}
        deletionModule={deletionModule}
        rating={rating}
        reviewMeta={reviewMeta}
      />
    </Box>
  );
};

export default ReviewWrapper;
